import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import useTriggerRMFFlow from '../../../../hooks/useTriggerRMFFlow';
import ButtonGroup from '../../../ButtonGroup/ButtonGroup';
import CTAButton from '../../../CTAButton/CTAButton';

import {
  TXTWCL_Before_you_can_depositX_we_nee_ELL_2,
  TXTWCL_Continue,
  TXTWCL_Just_a_moment_1
} from './DepositRmfRequired.messages.json';

const DepositRmfRequired: React.FC = () => {
  const jumpToRmf = useTriggerRMFFlow();
  const { data } = useWizardContext();
  return (
    <>
      <Translation tagName="h2" {...TXTWCL_Just_a_moment_1} />
      <Translation tagName="p" {...TXTWCL_Before_you_can_depositX_we_nee_ELL_2} />
      <ButtonGroup>
        <CTAButton
          type="button"
          translation={TXTWCL_Continue}
          onClick={() => {
            data.depositRmfRequiredPageVisited = true;
            jumpToRmf('#deposit.check-swf-flow', 'deposit');
          }}
        />
      </ButtonGroup>
    </>
  );
};

export default DepositRmfRequired;
